<script lang="ts">
    import {inviteId} from "../dateOptions";
    import {onMount} from 'svelte'
    import {loadInvite} from "../fetching/loadInvite";
    import ChooseDateAndTimeFromWeek from "../ChooseDateAndTimeFromWeek.svelte";
    import {error, notPaid} from "../stores";
    import AccessoriesView from "../AccessoriesView.svelte";
    import AboutYouAndYourCar from "../AboutYouAndYourCar.svelte";
    import InvitationPayment from "./InvitationPayment.svelte";
    import ThankYou from "../ThankYou.svelte";
    import Router from 'svelte-spa-router'
    import {wrap} from 'svelte-spa-router/wrap';
    import {fromDateIso, toDateIso} from "../state/appState";

    export let suppliedInviteId: string

    $inviteId = suppliedInviteId

    let loaded = false
    onMount(() => {
        loadInvite(suppliedInviteId, $fromDateIso, $toDateIso)
            .then(() => loaded = true)
            .catch(e => error.set(e.message))
    })

    const routes = {
        '/': wrap({component: ChooseDateAndTimeFromWeek, conditions: [notPaid]}),
        '/options': wrap({component: AccessoriesView, conditions: [notPaid]}),
        '/aboutYou': wrap({component: AboutYouAndYourCar, conditions: [notPaid]}),
        '/pay': wrap({component: InvitationPayment, conditions: [notPaid]}),
        '/thanks': wrap({component: ThankYou})
    }

</script>

{#if loaded && $inviteId}
    <Router {routes}/>
{:else}
    <div class="mt-5 margin-auto text-center">
        <h2>Checking availability...</h2>
    </div>
{/if}
